"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalAutoCoverageTypes = void 0;
var PersonalAutoCoverageTypes;
(function (PersonalAutoCoverageTypes) {
    PersonalAutoCoverageTypes["BODILY_INJURY_LIABILITY"] = "Bodily Injury Liability";
    PersonalAutoCoverageTypes["PROPERTY_DAMAGE_LIABILITY"] = "Property Damage Liability";
    PersonalAutoCoverageTypes["VEHICLE_LIABILITY"] = "Vehicle Liability";
    PersonalAutoCoverageTypes["UNINSURED_MOTORIST_BODILY_INJURY"] = "Uninsured Motorist Bodily Injury";
    PersonalAutoCoverageTypes["UNINSURED_MOTORIST_PROPERTY_DAMAGE"] = "Uninsured Motorist Property Damage";
    PersonalAutoCoverageTypes["COMPREHENSIVE"] = "Comprehensive";
    PersonalAutoCoverageTypes["COLLISION"] = "Collision";
    PersonalAutoCoverageTypes["COLLISION_DEDUCTIBLE_WAIVER"] = "Collision Deductible Waiver";
    PersonalAutoCoverageTypes["EMERGENCY_ROADSIDE"] = "Emergency Road Service";
    PersonalAutoCoverageTypes["CAR_RENTAL"] = "Car Rental & Travel Expenses";
    PersonalAutoCoverageTypes["MEDICAL_PAYMENT"] = "Medical Payments";
    PersonalAutoCoverageTypes["MECHANICAL_BREAKDOWN"] = "Mechanical Breakdown";
    PersonalAutoCoverageTypes["PIP"] = "Personal Injury Protection";
    PersonalAutoCoverageTypes["VANISHING_DEDUCTIBLE"] = "Vanishing Deductible";
    PersonalAutoCoverageTypes["RIDESHARE"] = "Rideshare Gap";
    PersonalAutoCoverageTypes["SUPPLEMENTARY_UNINSURED_UNDERINSURED_MOTORIST"] = "Supplementary Uninsured / Underinsured Motorist";
    PersonalAutoCoverageTypes["COMBINED_UNINSURED_UNDERINSURED_MOTORIST_BODILY_INJURY"] = "Uninsured / Underinsured Motorist Bodily Injury";
    PersonalAutoCoverageTypes["COMBINED_UNINSURED_UNDERINSURED_PROPERTY_DAMAGE"] = "Uninsured / Underinsured Motorist Property Damage";
    PersonalAutoCoverageTypes["OPTIONAL_BASIC_ECONOMIC_LOSS"] = "Optional Basic Economic Loss";
    PersonalAutoCoverageTypes["FUNERAL_BENEFITS"] = "Funeral Benefits";
    PersonalAutoCoverageTypes["FULL_VEHICLE_REPLACEMENT"] = "Full Vehicle Replacement";
    PersonalAutoCoverageTypes["PERSONAL_BELONGINGS"] = "Personal Belongings";
    // Wisconsin
    PersonalAutoCoverageTypes["ACCIDENTAL_DEATH"] = "Accidental Death and Dismemberment";
    PersonalAutoCoverageTypes["UNDERINSURED_MOTORIST_BODILY_INJURY"] = "Underinsured Motorist Bodily Injury";
    PersonalAutoCoverageTypes["ACCOMODATIONS"] = "Road Trip Accident Accomodations";
    // Washington
    PersonalAutoCoverageTypes["UNDERINSURED_MOTORIST_PROPERTY_DAMAGE"] = "Underinsured Motorist Property Damage";
    // Arizona
    PersonalAutoCoverageTypes["CUSTOM_PARTS"] = "Custom Parts and Equipment";
    PersonalAutoCoverageTypes["LOAN_PAYOFF"] = "Loan/Lease Payoff";
    // NY
    PersonalAutoCoverageTypes["COMPREHENSIVE_GLASS"] = "Comprehensive Glass";
    PersonalAutoCoverageTypes["WORK_LOSS"] = "Work Loss Benefit";
    PersonalAutoCoverageTypes["NECESSARY_EXPENSES"] = "Necessary Expenses";
    // SD
    PersonalAutoCoverageTypes["DISABILITY"] = "Disability";
    // KY
    PersonalAutoCoverageTypes["GUEST_PIP"] = "Guest Personal Injury Protection";
    PersonalAutoCoverageTypes["ADDITIONAL_PIP"] = "Additional Personal Injury Protection";
    // NJ
    PersonalAutoCoverageTypes["EXTENDED_MEDICAL_EXPENSE"] = "Extended Medical Expense";
    // NY
    PersonalAutoCoverageTypes["SUPPLEMENTAL_SPOUSAL_LIABILITY"] = "Supplemental Spousal Liability";
    PersonalAutoCoverageTypes["LAW_ENFORCEMENT_FEE"] = "Law Enforcement Fee";
    // MI
    PersonalAutoCoverageTypes["PROPERTY_PROTECTION_INSURANCE"] = "Property Protection Insurance";
    PersonalAutoCoverageTypes["LIMITED_PROPERTY_DAMAGE"] = "Limited Property Damage";
    // MA
    PersonalAutoCoverageTypes["OPTIONAL_BODILY_INJURY_LIABILITY"] = "Optional Bodily Injury to Others";
    // PA
    PersonalAutoCoverageTypes["EXTENDED_MEDICAL_BENEFITS"] = "Extended Medical Benefits";
})(PersonalAutoCoverageTypes = exports.PersonalAutoCoverageTypes || (exports.PersonalAutoCoverageTypes = {}));
